(function () {
  'use strict';

  var ENGRAVING_HANDLE = 'bottle-engraving';
  var LINE_PROPS = ['Engraving Line 1', 'Engraving Line 2', 'Engraving Line 3'];
  var engravingProduct = null;

  fetch('/products/' + ENGRAVING_HANDLE + '.js')
    .then(function (r) {
      if (!r.ok) throw new Error('Not found');
      return r.json();
    })
    .then(function (p) {
      engravingProduct = {
        variantId: p.variants[0].id,
        price: p.variants[0].price,
      };
      var priceFormatted =
        '$' + (engravingProduct.price / 100).toFixed(2);
      document.querySelectorAll('.engraving__price').forEach(function (el) {
        el.textContent = priceFormatted;
      });
      document.querySelectorAll('cart-engraving').forEach(function (el) {
        el.enable();
      });
    })
    .catch(function () {
      document.querySelectorAll('cart-engraving').forEach(function (el) {
        el.style.display = 'none';
      });
    });

  // Cart writes run one at a time, in order. The cart re-renders once the
  // queue drains, and checkout waits for it (see the click handler below).
  var opQueue = Promise.resolve();
  var pendingOps = 0;
  var needsRender = false;
  var leavingForCheckout = false;

  // Typing saves on its own after a short pause, so the fee line shows up
  // without the customer having to leave the box.
  var AUTOSAVE_MS = 700;
  // A cart redraw replaces this element mid-typing. `carry` hands the text,
  // focus and caret to the replacement; `keyMoves` follows a line item's key
  // as property changes give it a new one.
  var carry = {};
  var keyMoves = {};

  function currentKey(key) {
    var seen = 0;
    while (key && keyMoves[key] && seen++ < 20) key = keyMoves[key];
    return key;
  }

  function enqueue(fn) {
    pendingOps++;
    opQueue = opQueue
      .then(fn)
      .catch(function (e) { console.error('Engraving error:', e); })
      .then(function () {
        pendingOps--;
        if (pendingOps === 0 && needsRender && !leavingForCheckout) {
          needsRender = false;
          triggerCartUpdate();
        }
      });
    return opQueue;
  }

  class CartEngraving extends HTMLElement {
    connectedCallback() {
      this.line = parseInt(this.dataset.line);
      this.itemKey = this.dataset.key;
      this.variantId = this.dataset.variantId;
      this.productHandle = this.dataset.productHandle;
      this.isActive = this.dataset.active === 'true';
      this.itemQuantity = parseInt(this.dataset.itemQuantity);

      this.checkbox = this.querySelector('.engraving__checkbox');
      this.inputWrap = this.querySelector('.engraving__input-wrap');
      this.textInputs = this.querySelectorAll('.engraving__text');
      this.statusEl = this.querySelector('.engraving__status');

      if (!this.checkbox || !this.textInputs.length) return;

      // Snapshot of what is in (or queued for) the cart for this line.
      this.savedSnapshot = this.isActive ? this.snapshot() : '';
      this.serverSnapshot = this.savedSnapshot;

      this.addEventListener('change', function (e) {
        e.stopPropagation();
      });

      this.checkbox.addEventListener('change', this.handleToggle.bind(this));

      var self = this;
      this.textInputs.forEach(function (input) {
        input.addEventListener('input', function () {
          self.handleInput(input);
        });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            input.blur();
          }
        });
        input.addEventListener('focus', function () {
          self.focusedInput = input;
        });
        input.addEventListener('blur', function () {
          // A cart redraw blurs the field just before removing it. Wait a tick
          // so that case reads as "replaced", not "customer left the box".
          setTimeout(function () {
            if (!self.isConnected) return;
            if (self.focusedInput === input) self.focusedInput = null;
            self.handleBlurSave();
          }, 0);
        });
      });

      this.checkbox.disabled = !engravingProduct;
      this.restoreCarry();
    }

    disconnectedCallback() {
      clearTimeout(this.saveTimer);
      if (!this.checkbox || !this.checkbox.checked || !this.textInputs) return;
      var focused = this.focusedInput;
      var state = {
        at: Date.now(),
        known: [this.serverSnapshot, this.savedSnapshot],
        values: Array.prototype.map.call(this.textInputs, function (i) { return i.value; }),
        focus: focused ? Array.prototype.indexOf.call(this.textInputs, focused) : -1,
        selStart: focused ? focused.selectionStart : 0,
        selEnd: focused ? focused.selectionEnd : 0,
      };
      carry[currentKey(this.itemKey)] = state;
      if (this.dataset.key) carry[this.dataset.key] = state;
    }

    restoreCarry() {
      var key = this.dataset.key;
      var state = key && (carry[key] || carry[currentKey(key)]);
      if (!state) return;
      delete carry[key];
      delete carry[currentKey(key)];
      // Only carry typing over a redraw of the same state. If something else
      // changed this line (fee deleted, item edited elsewhere), start fresh.
      if (Date.now() - state.at > 5000) return;
      if (state.known.indexOf(this.serverSnapshot) === -1) return;

      this.checkbox.checked = true;
      this.inputWrap.hidden = false;
      var self = this;
      this.textInputs.forEach(function (input, idx) {
        if (state.values[idx] !== undefined && input.value !== state.values[idx]) {
          input.value = state.values[idx];
        }
        self.handleInput(input, true);
      });
      if (state.focus >= 0 && this.textInputs[state.focus]) {
        var target = this.textInputs[state.focus];
        target.focus();
        try { target.setSelectionRange(state.selStart, state.selEnd); } catch (e) {}
      }
      if (this.isDirty()) this.scheduleSave();
    }

    scheduleSave() {
      var self = this;
      clearTimeout(this.saveTimer);
      this.saveTimer = setTimeout(function () {
        if (self.isConnected && self.isDirty()) self.saveEngraving();
      }, AUTOSAVE_MS);
    }

    enable() {
      if (this.checkbox) this.checkbox.disabled = false;
    }

    handleToggle() {
      clearTimeout(this.saveTimer);
      if (this.checkbox.checked) {
        this.inputWrap.hidden = false;
        this.textInputs[0].focus();
      } else {
        this.textInputs.forEach(function (input) {
          input.value = '';
          var counter = input.parentElement.querySelector('.engraving__count');
          if (counter) counter.textContent = 0;
        });
        this.inputWrap.hidden = true;
        if (this.savedSnapshot) this.removeEngraving();
      }
    }

    handleInput(input, silent) {
      var counter = input.parentElement.querySelector('.engraving__count');
      if (counter) counter.textContent = input.value.length;
      if (this.statusEl) this.statusEl.hidden = true;
      if (!silent) this.scheduleSave();
    }

    handleBlurSave() {
      clearTimeout(this.saveTimer);
      if (!this.checkbox.checked) return;

      if (!this.hasAnyText()) {
        this.checkbox.checked = false;
        this.inputWrap.hidden = true;
        if (this.savedSnapshot) this.removeEngraving();
        return;
      }

      if (this.isDirty()) this.saveEngraving();
    }

    isDirty() {
      return !!this.checkbox && this.checkbox.checked && this.hasAnyText() &&
        this.snapshot() !== this.savedSnapshot;
    }

    snapshot() {
      var lines = this.getLineValues();
      return Object.keys(lines).length ? JSON.stringify(lines) : '';
    }

    getLineValues() {
      var lines = {};
      this.textInputs.forEach(function (input) {
        var num = input.dataset.lineNum;
        var val = input.value.trim();
        if (val) lines['Engraving Line ' + num] = val;
      });
      return lines;
    }

    hasAnyText() {
      var has = false;
      this.textInputs.forEach(function (input) {
        if (input.value.trim()) has = true;
      });
      return has;
    }

    saveEngraving() {
      if (!this.hasAnyText() || !engravingProduct) return;

      var self = this;
      var lineValues = this.getLineValues();
      this.savedSnapshot = this.snapshot();

      return enqueue(async function () {
        try {
          var cart = await fetchCart();
          var index = self.findIndex(cart);
          var lineItem = cart.items[index];
          if (!lineItem) throw new Error('Line item not found');

          var props = Object.assign({}, lineItem.properties || {});
          blankEngravingProps(props);
          Object.assign(props, lineValues);

          var changed = await cartChange({ line: index + 1, quantity: lineItem.quantity, properties: props });
          self.trackKey(changed, index);

          var updatedCart = await fetchCart();
          await ensureFee(updatedCart);
          needsRender = true;
        } catch (e) {
          self.savedSnapshot = '';
          self.setLoading(false);
          throw e;
        }
      });
    }

    removeEngraving() {
      var self = this;
      this.savedSnapshot = '';
      this.setLoading(true);

      return enqueue(async function () {
        try {
          var cart = await fetchCart();
          var index = self.findIndex(cart);
          var lineItem = cart.items[index];
          if (!lineItem) throw new Error('Line item not found');

          var props = Object.assign({}, lineItem.properties || {});
          blankEngravingProps(props);

          var changed = await cartChange({ line: index + 1, quantity: lineItem.quantity, properties: props });
          self.trackKey(changed, index);

          var updatedCart = await fetchCart();
          await ensureFee(updatedCart);
          needsRender = true;
        } catch (e) {
          self.setLoading(false);
          needsRender = true;
          throw e;
        }
      });
    }

    // Find this bottle by line item key, not position: adding the fee line
    // shifts positions, so a queued op would otherwise hit the wrong line.
    findIndex(cart) {
      var key = currentKey(this.itemKey);
      if (key) {
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) return i;
        }
        return -1;
      }
      return this.line - 1;
    }

    // Changing properties gives the line a new key; the position stays put.
    trackKey(cart, index) {
      if (this.itemKey && cart && cart.items && cart.items[index]) {
        var oldKey = currentKey(this.itemKey);
        var newKey = cart.items[index].key;
        if (newKey !== oldKey) keyMoves[oldKey] = newKey;
        this.itemKey = newKey;
      }
    }

    setLoading(loading) {
      // Only the text fields dim; the checkbox must stay clickable mid-save.
      if (this.inputWrap) this.inputWrap.classList.toggle('engraving--loading', loading);
    }
  }

  // Checkout used to beat the blur-triggered save. Save anything unsaved,
  // wait for queued cart writes, then re-click checkout.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"]');
    if (!btn) return;
    if (btn.dataset.engravingReady === '1') {
      delete btn.dataset.engravingReady;
      return;
    }

    var hasEngraving = false;
    document.querySelectorAll('cart-engraving').forEach(function (el) {
      if (el.isDirty && el.isDirty()) el.saveEngraving();
      if (el.savedSnapshot) hasEngraving = true;
    });
    if (pendingOps === 0 && !hasEngraving) return;
    enqueue(function () { return reconcile(true); });

    e.preventDefault();
    e.stopImmediatePropagation();
    leavingForCheckout = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.style.opacity = '0.6';

    // If a save hangs, give the button back rather than leaving it greyed.
    var released = false;
    var release = setTimeout(function () {
      released = true;
      leavingForCheckout = false;
      btn.removeAttribute('aria-disabled');
      btn.style.opacity = '';
    }, 10000);

    opQueue.then(function () {
      clearTimeout(release);
      if (released) return;
      var target = (btn.id && document.getElementById(btn.id)) || btn;
      target.dataset.engravingReady = '1';
      target.click();
    });
  }, true);

  if (!customElements.get('cart-engraving')) {
    customElements.define('cart-engraving', CartEngraving);
  }

  // /cart/change ignores properties that are simply left out (and an empty
  // properties object), so engraving keys have to be sent back as blanks.
  function blankEngravingProps(props) {
    LINE_PROPS.concat('Engraving Text').forEach(function (p) {
      if (p in props) props[p] = '';
    });
  }

  function hasEngravingText(item) {
    if (!item.properties) return false;
    return LINE_PROPS.some(function (p) {
      return item.properties[p] && item.properties[p].trim() !== '';
    }) || (item.properties['Engraving Text'] && item.properties['Engraving Text'].trim() !== '');
  }

  function countTotalEngravedQty(cart) {
    return cart.items
      .filter(function (i) {
        return i.handle !== ENGRAVING_HANDLE && hasEngravingText(i);
      })
      .reduce(function (sum, i) { return sum + i.quantity; }, 0);
  }

  function findFeeItems(cart) {
    return cart.items.filter(function (i) { return i.handle === ENGRAVING_HANDLE; });
  }

  async function ensureFee(cart) {
    if (!engravingProduct) return false;
    var totalNeeded = countTotalEngravedQty(cart);
    var feeItems = findFeeItems(cart);

    if (feeItems.length === 0) {
      if (totalNeeded > 0) {
        await cartAdd([{ id: engravingProduct.variantId, quantity: totalNeeded }]);
        return true;
      }
      return false;
    }

    if (feeItems.length === 1) {
      var fee = feeItems[0];
      if (totalNeeded === 0) {
        await cartChange({ line: cart.items.indexOf(fee) + 1, quantity: 0 });
        return true;
      }
      if (fee.quantity !== totalNeeded) {
        await cartChange({ line: cart.items.indexOf(fee) + 1, quantity: totalNeeded });
        return true;
      }
      return false;
    }

    var updates = {};
    feeItems.forEach(function (fee, idx) {
      updates[fee.key] = idx === 0 && totalNeeded > 0 ? totalNeeded : 0;
    });
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    });
    return true;
  }

  async function clearAllEngravingText(cart) {
    var cleared = false;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.handle === ENGRAVING_HANDLE || !hasEngravingText(item)) continue;
      var props = Object.assign({}, item.properties);
      blankEngravingProps(props);
      await cartChange({ line: i + 1, quantity: item.quantity, properties: props });
      cleared = true;
    }
    return cleared;
  }

  // Deleting the fee line means "no engraving": wipe the text off the bottles
  // so it can't reach checkout unpaid. Anything else keeps the fee in step.
  async function reconcile(clearIfNoFee) {
    if (!engravingProduct) return;
    var cart = await fetchCart();
    var changed;
    if (clearIfNoFee && findFeeItems(cart).length === 0 && countTotalEngravedQty(cart) > 0) {
      changed = await clearAllEngravingText(cart);
    } else {
      changed = await ensureFee(cart);
    }
    if (changed) needsRender = true;
  }

  function setupSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined')
      return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.source === 'engraving') return;
      enqueue(function () { return reconcile(event.source === 'cart-items'); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupSync);
  } else {
    setupSync();
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function cartChange(data) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(function (r) { return r.json(); });
  }

  function cartAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) { return r.json(); });
  }

  function triggerCartUpdate() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'engraving' });
    }
  }
})();
